var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        { staticClass: "login-form" },
        [
          _c(
            "el-form-item",
            [
              _c(
                "sw-input",
                {
                  attrs: {
                    size: "default",
                    placeholder: _vm.config.netidPlaceholder,
                    circular: "",
                  },
                  model: {
                    value: _vm.username,
                    callback: function ($$v) {
                      _vm.username = $$v
                    },
                    expression: "username",
                  },
                },
                [
                  _c("i", {
                    staticClass:
                      "su-input-icon black su-input-icon-prefix el-input__icon su-icon-people",
                    attrs: { slot: "prefix" },
                    slot: "prefix",
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "sw-input",
                {
                  attrs: {
                    size: "default",
                    placeholder: _vm.config.passwordPlaceholder,
                    circular: "",
                    "show-password": "",
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.login(
                        _vm.username,
                        _vm.password,
                        _vm.captcha,
                        _vm.rememberMe
                      )
                    },
                  },
                  model: {
                    value: _vm.password,
                    callback: function ($$v) {
                      _vm.password = $$v
                    },
                    expression: "password",
                  },
                },
                [
                  _c("i", {
                    staticClass:
                      "su-input-icon black su-input-icon-prefix el-input__icon su-icon-lock",
                    attrs: { slot: "prefix" },
                    slot: "prefix",
                  }),
                ]
              ),
              _vm.loginError
                ? _c("div", { staticClass: "login-error" }, [
                    _vm._v(" " + _vm._s(_vm.loginError) + " "),
                  ])
                : _vm._e(),
              _vm.config.rememberMe_timeToKillInSeconds != "0"
                ? _c(
                    "div",
                    { staticClass: "rember-password" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.rememberMe,
                            callback: function ($$v) {
                              _vm.rememberMe = $$v
                            },
                            expression: "rememberMe",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.i18n["screen.rememberme.checkbox.title"] ||
                                "记住我"
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticClass: "login-btn",
                  staticStyle: { width: "100%" },
                  attrs: {
                    size: "default",
                    type: "primary",
                    "native-type": "button",
                    round: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.login(
                        _vm.username,
                        _vm.password,
                        _vm.captcha,
                        _vm.rememberMe
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.i18n["screen.welcome.button.login"] || "登 录")
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "captcha-dialog-wrapper",
          attrs: {
            visible: _vm.captchaDialogVisible,
            "modal-append-to-body": "true",
            "append-to-body": "true",
            width: "450px",
            title: _vm.i18n["screen.captcha.title"] || "安全验证",
          },
          on: {
            "update:visible": function ($event) {
              _vm.captchaDialogVisible = $event
            },
            close: _vm.closeCaptcha,
          },
        },
        [
          _c(
            "div",
            { staticClass: "captcha-dialog-wrap" },
            [
              _c("div", { staticClass: "captcha-tip" }, [
                _vm._v(
                  _vm._s(
                    _vm.i18n["screen.captcha.warning"] ||
                      "您的操作疑似异常，请输入图形验证码"
                  )
                ),
              ]),
              _c("el-input", {
                staticClass: "input-style",
                model: {
                  value: _vm.captcha,
                  callback: function ($$v) {
                    _vm.captcha = $$v
                  },
                  expression: "captcha",
                },
              }),
              _c(
                "div",
                { staticClass: "captcha-img-wrap" },
                [
                  _c("img", { attrs: { src: _vm.captchaImgUrl, alt: "" } }),
                  _c(
                    "sw-button",
                    {
                      style: { color: `#${_vm.config.schemeColor}` },
                      attrs: { type: "text" },
                      on: { click: _vm.refreshCaptcha },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.i18n["screen.welcome.label.captcha.refresh"] ||
                            "看不清楚？换一张"
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "captcha-btn" },
                [
                  _c(
                    "sw-button",
                    {
                      style: {
                        color: `#${_vm.config.schemeColor}`,
                        borderColor: `#${_vm.config.schemeColor}`,
                      },
                      attrs: {
                        size: "small",
                        type: "primary",
                        simple: "",
                        round: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.captchaDialogVisible = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.i18n["screen.pm.button.cancel"] || "取消")
                      ),
                    ]
                  ),
                  _c(
                    "sw-button",
                    {
                      style: {
                        color: `#fff`,
                        backgroundColor: `#${_vm.config.schemeColor}`,
                        borderColor: `#${_vm.config.schemeColor}`,
                      },
                      attrs: { size: "small", type: "primary", round: "" },
                      on: {
                        click: function ($event) {
                          return _vm.captchaLogin(
                            _vm.username,
                            _vm.password,
                            _vm.captcha,
                            _vm.rememberMe
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.i18n["screen.pm.button.submit"] || "提交")
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }